module.exports = __webpack_public_path__ + "static/media/bicycle.4a2e2fa6.png";